import React from "react";
import { abonnerEtats } from "../../../store/external/fil";

// 04/11/2026 (registre n° 39) : pastille des échanges client dans la liste (colonne Statut).
// « Réponse client » (vert) = réponse en ligne non lue ; « Attente client » (orange) = dernier message envoyé par ATIS.
export default class FilBadge extends React.Component {
  constructor(props) {
    super(props);
    this.state = { etat: null };
  }

  componentDidMount() {
    this.fin = abonnerEtats((etats) => {
      const e = etats[String(this.props.requestId)] || null;
      if (e !== this.state.etat) this.setState({ etat: e });
    });
  }

  componentWillUnmount() {
    if (this.fin) this.fin();
  }

  render() {
    const { etat } = this.state;
    if (!etat) return null;
    const rep = etat === "reponse";
    return (
      <div align="center" style={{ marginTop: 3 }}>
        <span
          className="atis-fil-badge"
          title={rep ? "Le client a répondu en ligne (non lu)" : "Message envoyé, en attente de réponse du client"}
          style={{
            display: "inline-block",
            borderRadius: 12,
            padding: "1px 8px",
            fontSize: 11,
            fontWeight: 600,
            whiteSpace: "nowrap",
            background: rep ? "#DFF5E6" : "#FFF1E0",
            color: rep ? "#17733A" : "#A84A00",
          }}
        >
          {rep ? "Réponse client" : "Attente client"}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/Widget/FilBadge.js